import styled from 'styled-components';

/** Two printers to a row, like Bank Details above; one on a phone. */
export const PrinterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 40px;
  margin-bottom: 40px;

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
`;

/** A printer's text column, or its state column at the right edge. */
export const PrinterText = styled.div<{ $right?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $right }) => ($right ? 'flex-end' : 'flex-start')};
  gap: 4px;
  min-width: 0;
  flex: ${({ $right }) => ($right ? 'none' : '1')};
`;
